import React from "react";
import { parseVideo } from "../lib/api";

export default function VideoEmbed({ url, title = "video" }) {
  const parsed = parseVideo(url);
  if (!parsed) return null;
  return (
    <div className="relative w-full overflow-hidden" style={{ paddingTop: "56.25%", borderRadius: "var(--bn-card-radius)" }}>
      <iframe
        src={parsed.src}
        title={title}
        allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
        allowFullScreen
        frameBorder="0"
        className="absolute inset-0 w-full h-full"
      />
    </div>
  );
}
